module.exports = __webpack_public_path__ + "images/roundedThumbDark.8f295913.webp";